import React, { Component } from 'react';
import { connect } from 'react-redux'; // Import connect from react-redux
import { setUser } from '../../actions'; // Import setUser action
import LandingPage from '../../components/LandingPage';

class LandingPageContainer extends Component {
  render() {
    const { user, firebase, setUser } = this.props; // Access user and setUser from props

    return <LandingPage userData={user} engine={firebase} setUser={setUser}/>; // Pass user data, engine, and setUser as props to LandingPage
  }
}

// Map state to props
const mapStateToProps = state => ({
  user: state.user, // Access user from Redux state
});

// Map dispatch to props
const mapDispatchToProps = dispatch => ({
  setUser: user => dispatch(setUser(user)),
});

// Connect LandingPageContainer to Redux store
export default connect(mapStateToProps, mapDispatchToProps)(LandingPageContainer);